// A Search's top people, ranked — T158 (28 Sep 2026).
//
// Made by the brain's agent (`shortlist`) and kept by the brain API as made; in the brain's chat it
// comes under her answer to save (ChatDownloads.tsx). The bytes come behind the login, so the button
// fetches them with its token and saves them itself, as the Profile PDF button does (profilePdf.ts).
import { API_PREFIX, type RequestFn } from './core.ts';

export const shortlistsApi = (request: RequestFn) => ({
  pdf: (shortlistId: string) =>
    request<ArrayBuffer>(`${API_PREFIX}/shortlists/${shortlistId}/pdf`, { binary: true }),
});
